import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getBannerConfig } from './config';
import './HomeCardBanner.scss';

const HomeCardBanner = React.memo(({ bannerName, isOneColumnView }) => {
  const [isFlipped, setFlipped] = useState(false);
  const frontCard = useRef();
  const backCard = useRef();

  const banner = getBannerConfig(bannerName);

  useEffect(() => {
    if (isFlipped) {
      banner.track();
    }
  }, [banner, bannerName, isFlipped]);

  useEffect(() => {
    if (backCard.current && frontCard.current) {
      frontCard.current.style.height = null;
      backCard.current.style.height = null;

      if (isOneColumnView) {
        if (backCard.current.clientHeight > frontCard.current.clientHeight) {
          frontCard.current.style.height = `${backCard.current.clientHeight}px`;
        } else {
          backCard.current.style.height = `${frontCard.current.clientHeight}px`;
        }
      }
    }
  }, [isOneColumnView]);

  const homeCardBannerCn = classNames({
    'home-card-banner': true,
    'home-card-banner--flipped': isFlipped,
    'home-card-banner--multi-column-view': !isOneColumnView
  });

  return (
    <div className={homeCardBannerCn}>
      <div
        className={`home-card-banner__wrapper home-card-banner__wrapper--${banner.className}`}
      >
        <div
          className="home-card-banner__side home-card-banner__side--back"
          onClick={() => setFlipped(!isFlipped)}
          role="button"
          tabIndex="0"
          ref={backCard}
        >
          {banner.renderBack({ isOneColumnView })}
        </div>
        <div
          className="home-card-banner__side home-card-banner__side--front"
          onClick={() => setFlipped(!isFlipped)}
          role="button"
          tabIndex="0"
          ref={frontCard}
        >
          {banner.renderFront(isOneColumnView)}
        </div>
      </div>
    </div>
  );
});

HomeCardBanner.displayName = 'HomeCardBanner';

HomeCardBanner.propTypes = {
  bannerName: PropTypes.string.isRequired,
  isOneColumnView: PropTypes.bool.isRequired
};

export default HomeCardBanner;
